import React, { useState, useEffect, useRef } from "react";
import {
  QIDropdown,
  QIModal,
  QIModalBody,
  QIModalFooter,
  QIButton,
  QICustomDateRangePicker,
} from "../../../components";
import { useNavigate, useLocation } from "react-router-dom";
import { SvgIcon, ApplicationIcon } from "../../Shared";
import { FMDPStorage } from "../../../shared/helper";
import { toggleAppInfo } from "../../Authentication/helper";
import { getPreferredLanguage, persistPreferredLanguage, tHelper } from "../../../shared/translation";
import { smallLogo, userPlaceholder } from "../../../assets/";
import {
  useCreateAuthMutation,
  useSelectClientAppMutation,
  useSelectSuperAdminMutation,
  useLogoutAppMutation,
} from "../../Authentication/service";
import {
  useGetLanguagesQuery,
  useGetLocalizationsQuery,
  useUpdateUserProfileMutation,
  useChangeLayoutMutation,
  useGetLayoutsQuery,
} from "../../ManagementPortal/services";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setFlashScreen } from "../../../reduxStore/features";
import { getLocalizedString } from "../../../shared/translation";
import { useDropDownSearch } from "../../../hooks";
import { useGetDisplayConfigQuery } from "../../ManagementPortal/services";
import { setGlobalLiveLastDataTime, setGlobalCustomJson } from "../../../reduxStore/features";
//Toast Message
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const CommonHeader = ({
  appName,
  appToToggle,
  setLayoutSelectedAppId,
  setDefaultTrackingPage,
  onLocalizationsLoaded,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedAppId, setSelectedAppId] = useState(FMDPStorage.get("selected-app-id"));
  const [appToBeSelected, setAppToBeSelected] = useState("");
  const [dropDownSection, setDropDownSection] = useState("");
  const [quickDashboard, setQuickDashBoard] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [gridSelectedApp, setGridSelectedApp] = useState(null);
  const [showConfirmationModal, setshowConfirmationModal] = useState();
  const [configId, setConfigId] = useState(null);

  let selectedRange = useSelector((state) => state.common.selectedRange);
  let currentTab = useSelector((state) => state.common.currentTab);
  let globalResetCount = useSelector((state) => state.common.globalResetCount);
  let currentUrl = location.pathname.split("/").filter(Boolean).pop();

  const dashboardRef = useRef(null);

  const [
    selectClientApp,
    {
      isSuccess: selectClientAppSuccess,
      data: clientAppData,
      reset: resetSelectClientApp,
      error: selectClientAppError,
    },
  ] = useSelectClientAppMutation({
    fixedCacheKey: "shared-client-app-data",
  });

  const [
    selectSuperAdmin,
    {
      isSuccess: selectSuperAdminSuccess,
      reset: resetSelectSuperAdmin,
      error: selectSuperAdminError,
    },
  ] = useSelectSuperAdminMutation({
    fixedCacheKey: "shared-superadmin-app-data",
  });

  const [, { data: user }] = useCreateAuthMutation({
    fixedCacheKey: "shared-sso-data",
  });

  const [logoutApp, { isSuccess: logoutAppSuccess, reset: resetlogoutApp, error: logoutAppError }] =
    useLogoutAppMutation();

  const { data: languages } = useGetLanguagesQuery({
    per_page: 1000,
    order_by: "name",
    application_variant_id: 1,
  });

  const currentUserDetails = FMDPStorage.get("current-user");
  const selectedClientId = FMDPStorage.get("selected-client-id");
  const layout = currentUserDetails?.layout === "Default" ? false : true;
  const [isAlternativeUI, setIsAlternativeUI] = useState();
  let tempCustomJson = {};

  useEffect(() => {
    setIsAlternativeUI(layout);
  }, [layout]);

  // console.log(FMDPStorage.get("selected-app"));

  // Get the user config json and the localization profile
  let userConfigJson = "";
  let LocalizationProfile = "";
  let trackpointsSelectedRange = 10;

  try {
    const clientConfig = currentUserDetails?.client_apps?.find(
      (app) => app.id === selectedAppId
    )?.client?.config_json;
    LocalizationProfile = JSON.parse(clientConfig || "{}")?.tracking?.web?.localization_profile;
  } catch {}

  useEffect(() => {
    if (currentUserDetails?.client_apps && selectedAppId) {
      currentUserDetails.client_apps.forEach((user) => {
        if (user?.id === selectedAppId) {
          userConfigJson = user?.client?.config_json;
          try {
            const parsedConfig = JSON?.parse(userConfigJson);
            dispatch(setGlobalCustomJson(parsedConfig));
            // Store in localStorage for access in other useEffect
            localStorage.setItem("temp-custom-json", JSON.stringify(parsedConfig));
          } catch (e) {
            console.log(e);
          }
        }
      });
    }
  }, [currentUserDetails, selectedAppId, dispatch]);

  useEffect(() => {
    try {
      const tempCustomJson = FMDPStorage.get("temp-custom-json");
      if (tempCustomJson) {
        const tempLiveTabDuration = tempCustomJson?.tracking?.web?.live_tab_last_mins_data;
        if (tempLiveTabDuration >= 10 && tempLiveTabDuration <= 30) {
          trackpointsSelectedRange = tempLiveTabDuration;
        } else if (tempLiveTabDuration < 10) {
          trackpointsSelectedRange = 10;
        } else if (tempLiveTabDuration > 30) {
          trackpointsSelectedRange = 30;
        }
        dispatch(setGlobalLiveLastDataTime(trackpointsSelectedRange));
      }
    } catch (e) {
      console.log(e);
    }
  }, [dispatch]);

  const profile = FMDPStorage.get("localization-profile") || "";

  const {
    data: localizationData,
    isSuccess: isLocalizationSuccess,
    isLoading: isLocalizationLoading,
    error: localizationError,
  } = useGetLocalizationsQuery({
    language: getPreferredLanguage(),
    profile: profile || LocalizationProfile || "Tracksynq Web",
    per_page: 1000,
  });

  // Get the layouts list
  const { data: layouts, isSuccess: isLayoutsSuccess } = useDropDownSearch({
    useData: useGetLayoutsQuery,
    simpleSearchKey: "name_cont",
  });

  const [, setLoadedLocalizations] = useState(null);

  useEffect(() => {
    const result = {};
    if (localizationData?.data) {
      localizationData?.data?.forEach((item) => {
        result[item.key] = item.value;
      });
      const translations = JSON.stringify(result);
      tHelper.setLocalizations(translations);
      setLoadedLocalizations(translations);
      onLocalizationsLoaded?.(translations);
    } else if (localizationError) {
      onLocalizationsLoaded?.(true);
    }
  }, [localizationData, localizationError, onLocalizationsLoaded]);

  // Show toast when selected language has no localized text
  const [showDefaultLangMsg, setShowDefaultLangMsg] = useState(false);

  useEffect(() => {
    if (isLocalizationSuccess && localizationData?.data?.length === 0) {
      setShowDefaultLangMsg(true);
    } else {
      setShowDefaultLangMsg(false);
    }
  }, [isLocalizationSuccess, localizationData]);

  useEffect(() => {
    if (showDefaultLangMsg) {
      toast.error(
        "The selected language is not supported. Try selecting a different language.",
        {
          toastId: "unsupported-language",
          onClose: () => setShowDefaultLangMsg(false),
        }
      );
    }
  }, [showDefaultLangMsg]);

  const [update] = useUpdateUserProfileMutation();
  const [updateLayout, { error: layoutError, isSuccess: isSuccessLayout }] =
    useChangeLayoutMutation();

  useEffect(() => {
    if (languages) {
      tHelper.setSupportedLanguage(languages);
    }
  }, [languages]);

  const clientName = localStorage.getItem("selected-client") || "";

  const logOut = () => {
    logoutApp();
  };

  useEffect(() => {
    if (logoutAppSuccess) {
      FMDPStorage.clear();
      window.location.reload();
    }
  }, [logoutAppSuccess]);

  const switchApplication = () => {
    if (user.superadmin && selectedAppId !== appToBeSelected && appToBeSelected == "superadmin") {
      selectSuperAdmin();
    } else if (appToBeSelected !== selectedAppId) {
      selectClientApp({ client_app_id: appToBeSelected });
    }
  };

  // Navigate to app and toggle app info once app is changed
  useEffect(() => {
    if (selectClientAppSuccess) {
      toggleAppInfo(user, appToBeSelected || appToToggle, clientAppData).then((success) => {
        if (success) {
          dispatch(setGlobalCustomJson(null));
          setSelectedAppId(appToBeSelected || appToToggle);
          //Remove Modal;
          setAppToBeSelected("");
          navigate("/");
        }
      });
      resetSelectClientApp();
    }
  }, [selectClientAppSuccess]);

  // Navigate to admin dashboard if selected as super admin
  useEffect(() => {
    if (selectSuperAdminSuccess) {
      FMDPStorage.set("selected-app", "SuperAdmin");
      FMDPStorage.set("selected-app-id", "superadmin");
      FMDPStorage.set("selected-client", "");
      navigate("/");
      resetSelectSuperAdmin();
    }
  }, [selectSuperAdminSuccess, selectSuperAdminError]);

  const initiateAppChange = (appId) => {
    if (appId !== selectedAppId) {
      setAppToBeSelected(appId);
      setLayoutSelectedAppId(appId);
    }
  };

  const getAppName = (app) => {
    let clientName = "";
    let names = app?.name?.split("-") || [];

    if (names.length > 0) {
      clientName = names[0];
    }
    if (app?.custom_name?.trim()) {
      return `${clientName} - ${app.custom_name}`;
    }
    return app.name;
  };

  const getHeaderNameAndLogo = () => {
    const selectedApp = user?.client_apps?.filter(
      (i) => i?.id === FMDPStorage.get("selected-app-id")
    )[0];

    // TEMPORARY: Handle missing app data (for development/testing)
    if (!selectedApp) {
      const appName = FMDPStorage.get("selected-app") || "Application";
      return {
        name: appName.replace(/([A-Z])/g, " $1").trim(), // Convert camelCase to spaces
        logo: null,
      };
    }

    let { client, custom_name, name, image_url } = selectedApp;

    if (custom_name?.trim()) {
      return { name: custom_name, logo: image_url ? image_url : client?.image_url };
    } else {
      name = name.split("-").join(" ");
      return { name: name, logo: image_url ? image_url : client?.image_url };
    }
  };

  //set co_branding screen
  useEffect(() => {
    if (
      clientAppData?.user_sessions?.client_app?.client?.co_branding_screen === true ||
      clientAppData?.user_sessions?.client_app?.client?.co_branding_screen === false
    ) {
      dispatch(
        setFlashScreen(clientAppData?.user_sessions?.client_app?.client?.co_branding_screen)
      );
    }
  }, [dispatch, clientAppData]);

  const handleLanguageChange = async (language) => {
    try {
      await persistPreferredLanguage({
        currentUser: currentUserDetails,
        language,
        updateProfile: (payload) => update(payload).unwrap(),
      });
    } catch {
      toast.error("Unable to change language. Please try again.", {
        toastId: "language-update-failed",
      });
    }
  };

  // Change layout
  const handleLayoutChange = (layout) => {
    updateLayout({ id: currentUserDetails?.id, formData: { layout_id: layout.id } });
  };

  // Reload page after layout change
  useEffect(() => {
    if (isSuccessLayout) {
      window.location.reload();
    }
  }, [isSuccessLayout]);

  const goToDashboard = () => {
    FMDPStorage.set("app_features", null);
    FMDPStorage.set("selected-client", null);
    FMDPStorage.set("selected-app", null);
    FMDPStorage.set("selected-app-id", null);
    FMDPStorage.set("created-by-client-id", null);
    FMDPStorage.set("created-by-reseller", null);
    FMDPStorage.set("reseller", null);
    navigate("/app-selection");
  };

  const handleClickOutside = (event) => {
    if (dashboardRef.current && !dashboardRef.current.contains(event.target)) {
      // Clicked outside the config div, set showConfig to false
      setQuickDashBoard(false);
    }
  };

  useEffect(() => {
    // Add event listener on mount
    document.addEventListener("mousedown", handleClickOutside);

    // Remove event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Empty dependency array ensures the effect runs only on mount and unmount

  useEffect(() => {
    if (appToBeSelected) {
      switchApplication();
    }
  }, [appToBeSelected]);

  useEffect(() => {
    if (selectClientAppSuccess) {
      setShowModal(false);
    }
  }, [selectClientAppSuccess]);

  // Only initiate app change when modal is shown but confirmation is NOT needed
  // (i.e., switching within the same client)
  useEffect(() => {
    if (showModal && showConfirmationModal === false && gridSelectedApp?.id) {
      setConfigId(gridSelectedApp.displayConfigId);
      initiateAppChange(gridSelectedApp.id);
    }
  }, [showModal, showConfirmationModal, gridSelectedApp]);

  const handleGridSelection = (app) => {
    setQuickDashBoard(false);

    if (app.id === selectedAppId) {
      setGridSelectedApp(null);
      setShowModal(false);
      setshowConfirmationModal(false);
      return;
    }

    setGridSelectedApp(app);
    setshowConfirmationModal(true);
    setShowModal(true);
  };

  const getLayoutClassName = (layout) => {
    if (isAlternativeUI) {
      if (layout === "Default") {
        return "";
      } else {
        return "active";
      }
    } else {
      if (layout === "Default") {
        return "active";
      } else {
        return "";
      }
    }
  };

  //Display config query - only fetch when we're actually switching apps, not just selecting
  const { data: displayConfig } = useGetDisplayConfigQuery(
    { id: configId },
    {
      skip: !configId || showConfirmationModal, // Skip query while confirmation modal is shown
      refetchOnMountOrArgChange: true,
    }
  );

  // Only update default tracking page after successful app switch (when modal is closed)
  useEffect(() => {
    if (displayConfig && !showModal && !showConfirmationModal) {
      setDefaultTrackingPage(displayConfig?.default_tracking_portal_landing);
    }
  }, [displayConfig, showModal, showConfirmationModal]);

  const showCustomLabel = (currentUrl) => {
    const labels = ["events"];
    if (labels.includes(currentUrl)) {
      return true;
    }
    return false;
  };

  return (
    <header className="qi-header">
      <ApplicationIcon
        as="span"
        wrapperClassName="branding"
        imageUrl={getHeaderNameAndLogo()?.logo}
        fallbackComponent={<img alt="" src={smallLogo} />}
        alt={getHeaderNameAndLogo()?.name || "Application logo"}
      />

      <h3 className="qi-header_title text-center">
        <strong className="qi-header_title_text" onClick={() => navigate("/")}>
          {getHeaderNameAndLogo().name}
        </strong>
      </h3>
      <div className="qi-header_nav">
        {FMDPStorage.get("selected-app") !== "EcoDriveDriverScore" && (
          <div className="mr-3">
            {currentUrl !== "reports" &&
              currentUrl !== "vehicles" &&
              currentUrl !== "devices" &&
              currentTab === "Map" && (
                <QICustomDateRangePicker
                  resetCount={globalResetCount}
                  selectedRange={selectedRange}
                  openCalendar="left"
                  appName={appName}
                  showCustomLabel={showCustomLabel(currentUrl)}
                />
              )}
          </div>
        )}
        <div ref={dashboardRef} className="quick-dashboard">
          {(user?.client_apps?.length > 1 ||
            (user?.client_apps?.length === 1 && user?.superadmin)) && (
            <button onClick={() => setQuickDashBoard((prev) => !prev)}>
              <SvgIcon name={"grid"} />
            </button>
          )}
          {quickDashboard && (
            <div className="switch-apps">
              <Scrollbars autoHeight autoHeightMax="600px">
                <ul className="switch-apps_list">
                  <li className="switch-apps_list_item" onClick={goToDashboard}>
                    <SvgIcon name="back" wrapperClass="p-2" />
                    <strong>
                      {getLocalizedString("go_to_dashboard", "Clients and Applications")}
                    </strong>
                  </li>
                  {user.superadmin && (
                    <li
                      className={`switch-apps_list_item ${
                        selectedAppId === "superadmin" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleGridSelection({ id: "superadmin", displayConfigId: null });
                      }}
                    >
                      <div className="application-icon-wrapper">
                        <SvgIcon name="crown" wrapperClass="crown-icon" svgClass="icon-crown" />
                      </div>
                      <span>{getLocalizedString("superadmin", "Superadmin")}</span>
                    </li>
                  )}
                  {user?.client_apps?.map((app, index) => (
                    <li
                      className={`switch-apps_list_item ${
                        selectedAppId === app?.id ? "active" : ""
                      }`}
                      key={index}
                      onClick={() => {
                        handleGridSelection({
                          id: app.id,
                          displayConfigId: app?.client?.display_configuration_id
                        });
                      }}
                    >
                      <ApplicationIcon
                        imageUrl={app.image_url || app?.client?.image_url}
                        alt={getAppName(app)}
                      />
                      <span>{getAppName(app)}</span>
                    </li>
                  ))}
                </ul>
              </Scrollbars>
            </div>
          )}
        </div>
        <QIDropdown
          onHide={() => setDropDownSection("")}
          className="user-action-dropdown"
          toggleComponent={
            <div className="user-profile-name">
              <div className="user-profile-image-container">
                <img
                  className="user-profile-image"
                  alt="user-profile"
                  src={user?.thumbnail ? user?.thumbnail : userPlaceholder}
                />
              </div>
              <strong>
                {user.first_name || getLocalizedString("unknown", "Unknown")} {user.last_name || ""}
              </strong>
            </div>
          }
        >
          {dropDownSection === "" && (
            <ul className="user-dropdown">
              <li className="user-dropdown_user-info">
                <strong>{`${user.first_name} ${user.last_name}`}</strong>
                <p>{user.email || ""}</p>
              </li>

              {/* <li className="user-dropdown_link">
                <a
                  className="user-dropdown_link_item clickable"
                  onClick={() => setDropDownSection("application-switch")}
                >
                  <SvgIcon name="switch" />
                  <span>
                    {getLocalizedString("switch_applications", "Switch Applications")}
                  </span>
                </a>
              </li> */}

              <li className="user-dropdown_link">
                <a
                  className="user-dropdown_link_item clickable"
                  onClick={() => setDropDownSection("language-change")}
                >
                  <SvgIcon name="language" />
                  <span>{getLocalizedString("change_language", "Change Language")}</span>
                </a>
              </li>

              {/* <li className="user-dropdown_link">
                <a
                  className="user-dropdown_link_item clickable"
                  onClick={() => setDropDownSection("layout-change")}
                >
                  <SvgIcon name="layout" />
                  <span>{getLocalizedString("change_layout", "Change Layout")}</span>
                </a>
              </li> */}

              <li className="user-dropdown_link">
                <a
                  className="user-dropdown_link_item clickable"
                  onClick={() => setDropDownSection("layout-change")}
                >
                  <SvgIcon name="layout" />
                  <span>{getLocalizedString("change_layout", "Change Layout")}</span>
                </a>
              </li>

              <li className="user-dropdown_link">
                <a className="user-dropdown_link_item clickable" onClick={logOut}>
                  <SvgIcon name="log-out" />
                  <span>{getLocalizedString("sign_out", "Sign Out")}</span>
                </a>
              </li>
            </ul>
          )}
          {/*  {dropDownSection === "application-switch" && (
            <Scrollbars autoHeight autoHeightMax="600px">
              <ul>
                <li className="user-dropdown_link" onClick={() => setDropDownSection("")}>
                  <SvgIcon name="back" wrapperClass="p-2" />
                  <strong>
                    {getLocalizedString("switch_application", "Switch Application")}
                  </strong>
                </li>
                {user.superadmin && (
                  <li
                    className={`user-dropdown_link ${
                      selectedAppId === "superadmin" ? "active" : ""
                    }`}
                    onClick={() => initiateAppChange("superadmin")}
                  >
                    <div className="application-icon-wrapper">
                      <SvgIcon name="crown" wrapperClass="crown-icon" svgClass="icon-crown" />
                    </div>
                    <span>{getLocalizedString("superadmin", "Superadmin")}</span>
                  </li>
                )}
                {user?.client_apps?.map((app, index) => (
                  <li
                    className={`user-dropdown_link flex ${
                      selectedAppId === app.id ? "active" : ""
                    }`}
                    key={index}
                    onClick={() => initiateAppChange(app.id)}
                  >
                    <div className="application-icon-wrapper">
                      {app.image_url ? (
                        <span className="application-icon_wrapper">
                          <img src={app.image_url} className="application-icon" />
                        </span>
                      ) : (
                        <SvgIcon name="app-icon" wrapperClass="application-icon defult" />
                      )}
                    </div>
                    <span>{getAppName(app)}</span>
                  </li>
                ))}
              </ul>
            </Scrollbars>
          )} */}

          {dropDownSection === "layout-change" && (
            <Scrollbars autoHeight autoHeightMax="600px">
              <ul>
                <li className="user-dropdown_link" onClick={() => setDropDownSection("")}>
                  <SvgIcon name="back" wrapperClass="p-2" />
                  <strong>{getLocalizedString("change_language", "Change Layout")}</strong>
                </li>
                {layouts?.data?.map((layout) => (
                  <Scrollbars autoHeight autoHeightMax="600px">
                    <li
                      className={`user-dropdown_link ${getLayoutClassName(layout?.name)}`}
                      value={layout.id}
                      onClick={() => handleLayoutChange(layout)}
                    >
                      {layout.name}
                    </li>
                  </Scrollbars>
                ))}
              </ul>
            </Scrollbars>
          )}
          {dropDownSection === "language-change" && (
            <Scrollbars autoHeight autoHeightMax="600px">
              <ul>
                <li className="user-dropdown_link" onClick={() => setDropDownSection("")}>
                  <SvgIcon name="back" wrapperClass="p-2" />
                  <strong>{getLocalizedString("change_language", "Change Language")}</strong>
                </li>

                <li
                  className={`user-dropdown_link ${
                    getPreferredLanguage() === "en" ? "active" : ""
                  }`}
                  value={1}
                  onClick={() => handleLanguageChange({ id: 1, code: "en", name: "English" })}
                >
                  English
                </li>
                {languages?.data?.map((language) => (
                  <Scrollbars autoHeight autoHeightMax="600px">
                    <li
                      className={`user-dropdown_link ${
                        getPreferredLanguage() === language?.code ? "active" : ""
                      }`}
                      value={language.id}
                      onClick={() => handleLanguageChange(language)}
                    >
                      {language.name}
                    </li>
                  </Scrollbars>
                ))}
              </ul>
            </Scrollbars>
          )}
        </QIDropdown>
      </div>
      {showConfirmationModal && showModal && (
        <QIModal show={showModal} scrollable={true} className="confirm">
          <QIModalBody>
            <h2 className="page-title mb-4 text-center">
              {getLocalizedString("confirmation_alert", "Confirmation Alert") + "!"}
            </h2>
            <div className="confirmation-message">
              <span>
                <SvgIcon name="alert" className="confirmation-message_icon" />
              </span>
              <p className="text-center mb-4">
                {getLocalizedString(
                  "switch_application_message",
                  "You are about to switch application. Please save your existing work (if any) and confirm."
                )}
              </p>
              <p className="text-center">
                {getLocalizedString("are_you_sure", "Are you sure") + " ?"}
              </p>
              {(selectClientAppError || selectClientAppError) && (
                <p className="text-red-600">
                  {getLocalizedString(
                    "switch_application_wrong_message",
                    "Something went wrong, Unable to switch application"
                  )}
                </p>
              )}
            </div>
          </QIModalBody>
          <QIModalFooter>
            <QIButton
              onClick={() => {
                setShowModal(false);
              }}
              className="qi-btn secondary md"
              variant="secondary"
              size="sm"
            >
              {getLocalizedString("no", "No")}
            </QIButton>
            <QIButton
              onClick={() => {
                setConfigId(gridSelectedApp?.displayConfigId);
                initiateAppChange(gridSelectedApp?.id);
              }}
              size="sm"
              variant="danger"
              className="qi-btn primary md"
            >
              {getLocalizedString("yes", "Yes")}
            </QIButton>
          </QIModalFooter>
        </QIModal>
      )}
      <ToastContainer />
    </header>
  );
};
